import {
  buildHtml,
  buildLink,
  KitchenSinkRoute,
  RouteSlotInput,
} from '@luks/ui';

import { cleanList } from '../../commons/cleanList';
import { removeEmptyParagraphs } from '../../commons/preprocess-paragraphs';
import { buildDrupalImage } from '../Image';

function mapTeaser(teaser: TeaserFragment) {
  return {
    key: 'Teaser',
    input: {
      arrowIsVisible: true,
      Description: buildHtml(teaser.lead || ''),
      Image: teaser.image
        ? buildDrupalImage(teaser.image, 'teaser')
        : undefined,
      title: teaser.title || '',
      Link: teaser.link?.url ? buildLink({ href: teaser.link.url }) : null,
      isFullWidth: false,
    },
  };
}

export function mapTeasers(
  input: TeasersFragment,
): RouteSlotInput<
  typeof KitchenSinkRoute,
  'body',
  'GridTeaser' | 'SliderTeaser'
> {
  return {
    key: input.display === 'carousel' ? 'SliderTeaser' : 'GridTeaser',
    input: {
      title: input.title || '',
      teasers:
        removeEmptyParagraphs(input.teasers)
          .filter(cleanList)
          .map(mapTeaser)
          .map((v) => v.input) || [],
    },
  };
}
